import React from 'react';
import Box from '@mui/material/Box';
import makeStyles from '@mui/styles/makeStyles';
import Paper from '@mui/material/Paper';
import useResources from '@monorepo/shared/src/hooks/use-resources';
import ResourceFilters from './ResourceFilters';
import ResourceFiltersTags from './ResourceFiltersTags';
import useSectionTitle from '../hooks/useSectionTitle';

const ResourcesGrid: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [{ selectedFilters }] = useResources();

  const { title } = useSectionTitle(selectedFilters);

  const classes = useStyles();

  return (
    <div className={classes.resources}>
      <Paper elevation={4} className={classes.paper}>
        <ResourceFilters />
      </Paper>

      <Box px={24} overflow={'auto'}>
        <ResourceFiltersTags label={`${title}:`} />
        {children}
      </Box>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  paper: {
    marginBottom: '10px',
    paddingTop: '5px',
    position: 'relative',
    top: '-1px',
  },
  resources: {
    height: `calc(99vh - 2 * ${theme.typography.pxToRem(theme.constants.app.menuOffset)})`,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
}));

export default ResourcesGrid;
